<!-- <app-nav></app-nav>


<div [ngSwitch]="routeVal">
    <div *ngSwitchDefault>
        <app-associate-add-record></app-associate-add-record>
    </div>
    <div *ngSwitchCase="'1'">
        <app-associate-add-record></app-associate-add-record>
    </div>
    
</div>
<app-footer></app-footer> -->


<app-common-menu></app-common-menu>
